import { render } from "./SettingsManager.vue?vue&type=template&id=19af2787&scoped=true"
import script from "./SettingsManager.vue?vue&type=script&lang=js"
export * from "./SettingsManager.vue?vue&type=script&lang=js"

import "./SettingsManager.vue?vue&type=style&index=0&id=19af2787&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19af2787"]])

export default __exports__